import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getContextTokenRequestRequest = {};
var _getContextTokenRequestResponse = {};
var _getIssuedContextTokenRequest = {};
var _getIssuedContextTokenResponse = {};
var _listContextTokenRequestsRequest = {};
var _listContextTokenRequestsResponse = {};
function resolveWixSocialGroupsApiV2ContextTokensServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/social-groups-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/social-groups-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Get context token request for specific group.
 * Remark 1: right now works only for shared gallery app. Feed claim will be added later
 * Remark 2: maybe will be moved to middleware later
 */
export function getContextTokenRequest(payload) {
    return function __getContextTokenRequest(_a) {
        var host = _a.host;
        var toJSON = serializer(_getContextTokenRequestRequest, {}).toJSON;
        var fromJSON = serializer(_getContextTokenRequestResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixSocialGroupsApiV2ContextTokensServiceUrl({
                protoPath: '/v2/context-token-request/{groupId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Get context token requests for all groups.
 * Remark 1: right now works only for shared gallery app. Feed claim will be added later
 * Remark 2: maybe will be moved to middleware later
 */
export function listContextTokenRequests(payload) {
    return function __listContextTokenRequests(_a) {
        var host = _a.host;
        var toJSON = serializer(_listContextTokenRequestsRequest, {}).toJSON;
        var fromJSON = serializer(_listContextTokenRequestsResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixSocialGroupsApiV2ContextTokensServiceUrl({
                protoPath: '/v2/context-token-request',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Get social token for for specific group.
 * Remark: right now works only for shared gallery app. Feed claim will be added later
 */
export function getContextToken(payload) {
    return function __getContextToken(_a) {
        var host = _a.host;
        var toJSON = serializer(_getIssuedContextTokenRequest, {}).toJSON;
        var fromJSON = serializer(_getIssuedContextTokenResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixSocialGroupsApiV2ContextTokensServiceUrl({
                protoPath: '/v2/context-token/{groupId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
//# sourceMappingURL=http.js.map